import {styled} from "@mui/material";

export const AuthStatusContainer = styled('div')(() => {
    return {
        display: 'flex',
        padding: '2.25rem',
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: '0.5rem',
        gap: '1rem'
    }
});
